// utilfunktioner specifika för skötselfliken i gravplatsvy

import { TEDGASkotselArbUndStatusEnum } from '../../../../../../globalQueryTypes';

export const formatYearRange = (
  arFr: number | null | undefined,
  arTi: number | null | undefined
): string => {
  if (arFr && arTi) {
    // Båda finns - kolla om de är samma
    return arFr === arTi ? `${arFr}` : `${arFr} - ${arTi}`;
  } else if (arFr && !arTi) {
    // Endast startår finns
    return `${arFr} - tillsv`;
  } else if (!arFr && arTi) {
    // Endast slutår finns
    return `${arTi}`;
  }
  return '-';
};

export const hasHistoricalData = (
  currentLength: number,
  allLength: number
): boolean => {
  return allLength > currentLength;
};

export const getCurrentSkotselIds = (
  currentSkotsel: Array<{ id?: string }>
): Set<string> => {
  const ids = new Set<string>();
  currentSkotsel.forEach(item => {
    if (item?.id) ids.add(item.id);
  });
  return ids;
};

export const arbUndStatusLabel: Record<TEDGASkotselArbUndStatusEnum, string> = {
  [TEDGASkotselArbUndStatusEnum.EJ_AKTUELL]: 'Ej aktuell',
  [TEDGASkotselArbUndStatusEnum.EJ_BETALD]: 'Ej betald',
  [TEDGASkotselArbUndStatusEnum.EJ_FAKTURERAD]: 'Ej fakturerad',
  [TEDGASkotselArbUndStatusEnum.EJ_PA_ARB__UND_]: 'Ej på arbetsunderlag',
  [TEDGASkotselArbUndStatusEnum.KLAR_FOR_UTSKRIFT]: 'Klar för utskrift',
  [TEDGASkotselArbUndStatusEnum.SKAPAT]: 'Skapat',
  [TEDGASkotselArbUndStatusEnum.UTSKRIVET]: 'Utskrivet',
};
